export const youtubeApi = {
  youtubeDefaultUrl: process.env.REACT_APP_YOUTUBE_URL,
  playlistId: process.env.REACT_APP_PLAYLISTID,
  apiKey: process.env.REACT_APP_YOUTUBE_API_KEY,
  channelId: process.env.REACT_APP_CHANNEL_ID,
};
